export default __webpack_public_path__ + "static/media/Mark-4-Suit-09.6dbf8e42.jpg";